import {Image} from 'react-bootstrap';
import {IconBox, IconBoxSize} from '@Components/icon-box';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import Divider from '@Components/divider';
import {Button, Size, Type} from '@Components/button';
import React from 'react';
import styles from './auto-branding-intro-visual.module.scss';

export interface AutoBrandingIntroVisualProps {
  heading: string;
  description: string;
  buttonCta: VoidFunction;
  closeButtonCta?: VoidFunction;
  graphicSource?: string;
  buttonCtaText?: string;
  buttonType?: Type;
}

export function AutoBrandingIntroVisual({
  heading,
  description,
  buttonCta,
  closeButtonCta,
  graphicSource = '',
  buttonCtaText = window.i18next.t('pmwjs_try_it_now'),
  buttonType = Type.PRIMARY,
}: AutoBrandingIntroVisualProps): React.ReactElement {
  return (
    <div className={`${styles.background}`}>
      <Image className={`${styles.graphic}`} src={graphicSource} alt={window.i18next.t('pmwjs_image')} />
      <IconBox className={`${styles.closeIcon}`} iconSize={IconSize.SIZE_ICON_16} size={IconBoxSize.SMALL} icon="icon-close" onClick={closeButtonCta} />
      <div>
        <Text val={heading} size={TextSize.XXSMALL} bold className="content-body spacing-p-b-1" />
        <Text val={description} size={TextSize.XXSMALL} className={`${styles.description} content-sub-text`} />
      </div>
      <Divider additionalClasses={`${styles.divider}`} />
      <Button type={buttonType} size={Size.XSMALL} text={buttonCtaText} onClick={buttonCta} />
    </div>
  );
}
